import avatar from "../images/avatar.svg"
import emoticons from "../images/emoticons.svg"
import symbol from "../images/symbol.svg"
import signs from "../images/signs.svg"

export default [
  {
    icon: signs,
    number: 3,
    text: "Puncte de lucru ITP",
  },
  {
    icon: symbol,
    number: 13,
    text: "Ani de experienta",
  },
  {
    icon: avatar,
    number: 8,
    text: "Inspectori ITP",
  },
  {
    icon: emoticons,
    number: 1250,
    text: "Clienti multumiti",
  },
]
